import type { ProductInventoryItem } from '@/libs/interfaces'

/** Shared dashboard fixture data: static KPI numbers and inventory snapshot. */
export const mockKPITotalBilled = 125000
export const mockKPITotalBookings = 340
export const mockKPITotalServices = 12

export const mockInventoryStatus: ProductInventoryItem[] = [
  {
    productID: 'product-engine-oil',
    productName: 'Engine Oil 5W-30',
    productInventoryBalance: 48,
  },
  {
    productID: 'product-tire-set',
    productName: 'Winter Tire Set',
    productInventoryBalance: 16,
  },
  {
    productID: 'product-brake-pads',
    productName: 'Brake Pads (Front)',
    productInventoryBalance: 24,
  },
  {
    productID: 'product-wiper-blades',
    productName: 'Wiper Blades',
    productInventoryBalance: 60,
  },
  {
    productID: 'product-air-filter',
    productName: 'Air Filter',
    productInventoryBalance: 35,
  },
]
